exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daum-postcode[data-v-e3996250]{margin-bottom:15px}.daum-postcode .row[data-v-e3996250]{margin-top:15px}.daum-postcode .row[data-v-e3996250]:first-child{margin-top:0}.daum-postcode .row>div[data-v-e3996250]{padding-right:0}.daum-postcode .row>div[data-v-e3996250]:last-child{padding-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3996250","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/DaumPostcode.vue
// module id = 178
// module chunks = 0